// src/com/menu_info/MenuInfoGql.js
// Input dictionary, GQL, Table Header.
import { gql } from "@apollo/client";



const MENU_INFO_LIST_PART = gql`
fragment MenuInfoListPart on MenuInfo {
    treeOrder
    nodeType
    menuId
    parentMenuId
    menuName
    lastMenu
    menuUrl
    svcUrl
    menuType
    menuDesc
    classNo
    menuLevel
    menuIndex
    useYn
    menuEn
    menuJp
    menuCh
    regUser
    regDate
    nodeLevel
}
`;


export const LIST_MENU_INFO = gql`
${MENU_INFO_LIST_PART}
query ListMenuInfo {
    menuInfoList {
        ...MenuInfoListPart
    }
}
`;


export const LIST_MY_MENU_INFO = gql`
${MENU_INFO_LIST_PART}
query ListMenuInfo {
    menuInfoListMine {
        ...MenuInfoListPart
    }
}
`;

export const LIST_MENU_INFO_FOR = gql`
${MENU_INFO_LIST_PART}
query ListMenuInfoFor($authClassId:String!) {
    menuInfoListFor(authClassId:$authClassId) {
        ...MenuInfoListPart
    }
}
`;

export const LIST_MENU_INFO_NOT_FOR = gql`
${MENU_INFO_LIST_PART}
query ListMenuInfoNotFor($authClassId:String!) {
    menuInfoListNotFor(authClassId:$authClassId) {
        ...MenuInfoListPart
    }
}
`;

export const ADD_MENU_AUTH_ALLOC = gql`
mutation AddMenuAuthAlloc($menuAuthAlloc:InputMenuAuthAlloc!) {
    menuAuthAllocAdd(menuAuthAlloc:$menuAuthAlloc) {
        ok
        message
    }
}
`;

export const REMOVE_MENU_AUTH_ALLOC = gql`
mutation RemoveMenuAuthAlloc($menuAuthAlloc:InputMenuAuthAlloc!) {
    menuAuthAllocRemove(menuAuthAlloc:$menuAuthAlloc) {
        ok
        message
    }
}
`;

/*

extend type Mutation {
	menuAuthAllocAdd(menuAuthAlloc: InputMenuAuthAlloc!): CommonResponse
	menuAuthAllocRemove(menuAuthAlloc: InputMenuAuthAlloc!): CommonResponse
}

input InputMenuAuthAlloc {
	authClassId: String!
	menuId: Int!
}

*/


const LeafNodeType = 'leaf';

function recursiveWeedOut(menuList) {
    const newMenuList = [];
    menuList.forEach(menu => {
        if(menu.children) {
            menu.children = recursiveWeedOut(menu.children);
            newMenuList.push(menu);
        }
        else if(menu.nodeType === LeafNodeType) {
            newMenuList.push(menu);
        }
    });
    return newMenuList;

}

/**
 * Make menu tree from menuList.
 * Weed out menus that neither have children nor are last leaf menu. (last menu: nodeType === 'leaf')
 * @param {*} menuList 
 */
export function makeMenuTree(menuList) {
    const menuTree = [];
    const menuMap = new Map();
    menuList.forEach(menu => {
        menuMap.set(menu.menuId, menu);
    });

    menuList.forEach(menu => {
        if(menu.parentMenuId === 0) {
            menuTree.push(menu);
        }
        else {
            const parentMenu = menuMap.get(menu.parentMenuId);
            if(parentMenu) {
                if(!parentMenu.children) {
                    parentMenu.children = [];
                }
                parentMenu.children.push(menu);
            }
        }
    });

    // Weed out menus that neither have children nor are last leaf menu.
    return recursiveWeedOut(menuTree);
}
